import { NOTIFICATIONS_ACTION_TYPES } from '../actionTypes';

const initialRootNodes = {
  notifications: null,
  loading: false,
  error: null,
  selectedNotification: null,
};

const NotificationsReducer = (state = initialRootNodes, action) => {
  switch (action.type) {
    case NOTIFICATIONS_ACTION_TYPES.GET.IN_PROGRESS:
      return { ...state, loading: true, selectedNotification: null };
    case NOTIFICATIONS_ACTION_TYPES.GET.SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
        error: null,
      };
    case NOTIFICATIONS_ACTION_TYPES.GET.ERROR:
    case NOTIFICATIONS_ACTION_TYPES.DELETE.ERROR:
      return { ...state, notifications: null, loading: false, error: action.error };
    case NOTIFICATIONS_ACTION_TYPES.SELECT_NOTICIATION:
      return { ...state, selectedNotification: action.payload, loading: false, error: null };
    case NOTIFICATIONS_ACTION_TYPES.DELETE.SUCCESS:
      return { ...state, notifications: null, loading: false };
    default:
      return state;
  }
};

export default NotificationsReducer;
